import React, { useEffect } from "react";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";

import MainProjects from "./Sections/MainProjects";
import LastPosts from "./Sections/LastPosts";
import AllProjects from "./Sections/AllProjects";
import Services from "./Sections/Services";
import Partnerships from "./Sections/Partnerships";
import Dashboard from "views/admin/Dashboards/Dashboard";
import WhoWeAre from "./Sections/WhoWeAre";
import InefopDirectorMessage from "./Sections/InefopDirectorMessage";
import Statistics from "./Sections/Statistics";
import { getStructuringProjectsAction } from "redux/actions/informationDisseminationAction";
import { getWhoWeAreAction } from "redux/actions/applicationConfigurationAction";
import {
  INFORMATION_DISSEMINATION_TYPE_KEYVALUE,
  PAGINATION,
  APP_CONFIG_KEYVALUES,
} from "utils/const";
import { getUserWarningsStatus } from "crud/auth.crud";

const INITIAL_USER_WARNINGS = {
  hasInsufficientCooperativeMembers: false,
  hasMissingCooperativeRequiredFields: false,
  hasMissingInapemCertificate: false,
};

const USER_WARNING_MESSAGES = {
  hasInsufficientCooperativeMembers:
    "Após o registo da Cooperativa, deverá proceder à adição dos membros da Cooperativa através do Meu Perfil.",
  hasMissingCooperativeRequiredFields:
    "Tem informações obrigatórias por preencher no perfil da cooperativa. Aceda ao seu perfil para os completar.",
  hasMissingInapemCertificate:
    "Tem o certificado do INAPEM por submeter no perfil da cooperativa. Aceda ao seu perfil para o adicionar.",
};

function LandingPage(props) {
  const [userWarnings, setUserWarnings] = React.useState({
    ...INITIAL_USER_WARNINGS,
  });
  const [hasCheckedUserWarningsStatus, setHasCheckedUserWarningsStatus] =
    React.useState(false);

  useEffect(() => {
    let filter = {
      searchText: "",
      searchPublishPeriodKeyValue: undefined,
      informationDisseminationTypeKeyValueList: [
        INFORMATION_DISSEMINATION_TYPE_KEYVALUE.STRUCTURING_PROJECT,
      ],
      isPublic:
        props.authState.loggedIn !== undefined && props.authState.loggedIn
          ? null
          : true,
      published: true,
      isHighlighted: null,
      pageIndex: 1,
      pageSize: PAGINATION.PAGE_SIZE_STRUCTURING_PROJECTS,
    };

    props.getStructuringProjects(filter);

    props.getWhoWeAre();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!props.authState.loggedIn) {
      setUserWarnings({ ...INITIAL_USER_WARNINGS });
      setHasCheckedUserWarningsStatus(false);
      return;
    }

    if (hasCheckedUserWarningsStatus) {
      return;
    }

    getUserWarningsStatus()
      .then((res) => {
        setUserWarnings({
          hasInsufficientCooperativeMembers:
            !!res?.data?.hasInsufficientCooperativeMembers,
          hasMissingCooperativeRequiredFields:
            !!res?.data?.hasMissingCooperativeRequiredFields,
          hasMissingInapemCertificate: !!res?.data?.hasMissingInapemCertificate,
        });
      })
      .catch((error) => {
        console.log("error fetching user warnings status", error);
      })
      .finally(() => {
        setHasCheckedUserWarningsStatus(true);
      });
  }, [props.authState.loggedIn, hasCheckedUserWarningsStatus]);

  const visibleUserWarnings = Object.keys(USER_WARNING_MESSAGES).filter(
    (warningKey) => userWarnings[warningKey]
  );

  const handleCloseUserWarning = (warningKey) => {
    setUserWarnings((previousWarnings) => ({
      ...previousWarnings,
      [warningKey]: false,
    }));
  };

  const getWhoWeAreElementDescriptionBasedOnKeyValue = (keyValue) => {
    const whoWeAreResult = props.applicationConfigurationState?.whoWeAre_result;
    if (Array.isArray(whoWeAreResult)) {
      return whoWeAreResult.find((element) => element.keyValue === keyValue)?.description;
    }
    return undefined;
  };

  return (
    <div style={{ marginTop: "130px" }}>
      {visibleUserWarnings.map((warningKey) => (
        <Box px={2} pb={2}>
          <Alert
            severity="warning"
            onClose={() => handleCloseUserWarning(warningKey)}
          >
            {USER_WARNING_MESSAGES[warningKey]}
          </Alert>
        </Box>
      ))}
      {!props.isLoggedIn && (
        <MainProjects
          structuringProjects={
            props.informationDisseminationState?.structuringProjects_result
              ?.data
          }
        />
      )}
      <Services isLoggedIn={props.isLoggedIn} userType={props.userType} />
      {props.isLoggedIn && <Dashboard />}
      <LastPosts />
      <WhoWeAre
        inefopSummary={getWhoWeAreElementDescriptionBasedOnKeyValue(
          APP_CONFIG_KEYVALUES.INEFOP_SUMMARY
        )}
      />
      <Statistics />
      <AllProjects
        structuringProjects={
          props.informationDisseminationState?.structuringProjects_result?.data
        }
      ></AllProjects>
      <InefopDirectorMessage
        inefopDirectorMessage={getWhoWeAreElementDescriptionBasedOnKeyValue(
          APP_CONFIG_KEYVALUES.INEFOP_DIRECTOR_MESSAGE
        )}
      />
      <Partnerships />
    </div>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getStructuringProjects: (data) =>
    dispatch(getStructuringProjectsAction(data)),
  getWhoWeAre: () => dispatch(getWhoWeAreAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
